import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { categories } from '../mock';

const CategoriesSection = () => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-white">
      <div className="max-w-[1280px] mx-auto">
        {/* Top intro grid */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 mb-20 items-end">
          <div>
            <p className="text-xs md:text-sm text-gray-500 mb-4 tracking-[0.3em] uppercase">
              Exclusive Deals
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black leading-[1.15] tracking-tight">
              Furniture for every room, at factory-direct prices
            </h2>
          </div>
          <div>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-7 max-w-xl">
              Explore our extensive selection of mattresses, beds, sofas, dining sets and storage — handpicked for quality and value, with free delivery across Sydney.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/furniture"
                className="inline-flex items-center gap-2 bg-black text-white px-7 py-3 rounded-full text-sm font-medium hover:bg-gray-800 btn-transition"
              >
                Shop the collection
                <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
              </Link>
              <a
                href="tel:+61411418088"
                className="inline-flex items-center gap-2 border-2 border-black text-black px-7 py-3 rounded-full text-sm font-medium hover:bg-black hover:text-white btn-transition"
              >
                Call Now
              </a>
            </div>
          </div>
        </div>

        {/* Section Title */}
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
            Browse
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black font-display-serif tracking-tight">
            Shop by category
          </h2>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/furniture#${cat.slug}`}
              className="group relative block aspect-[4/5] rounded-2xl overflow-hidden bg-[#f7f5f1]"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-[1.04] transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <div className="flex items-end justify-between gap-3">
                  <h3 className="text-lg md:text-xl font-semibold text-white">
                    {cat.name}
                  </h3>
                  <span className="w-8 h-8 rounded-full bg-white/90 text-black flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex-shrink-0">
                    <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
